import { useState } from 'preact/hooks';
import { sendPostMessage } from '../../helpers/post-message.helper';
import { useStatistics } from '../../services/use-statistics';

export const timeOptions = [
  { id: 1, text: 'widget.manageHideMove.hideTime.current', type: 'current' },
  { id: 2, text: 'widget.manageHideMove.hideTime.day', type: 'day' },
  { id: 3, text: 'widget.manageHideMove.hideTime.week', type: 'week' },
  { id: 4, text: 'widget.manageHideMove.hideTime.month', type: 'month' },
  { id: 5, text: 'widget.manageHideMove.hideTime.indefinitely', type: 'indefinitely' },
];

const getTimeDiff = (type) => {
  const date = new Date();
  if (type === 'day') {
    date.setDate(date.getDate() + 1);
  } else if (type === 'week') {
    date.setDate(date.getDate() + 7);
  } else if (type === 'month') {
    date.setMonth(date.getMonth() + 1);
  }
  return date.getTime() - new Date().getTime();
};

export const useHideWidget = () => {
  const { sendStatistics } = useStatistics();
  const [selectedTime, setSelectedTime] = useState({ value: 1 });

  const setHide = () => {
    const { value } = selectedTime;
    const selected = timeOptions.filter((item) => item.id === value)[0];
    const time = getTimeDiff(selected.type);
    sendPostMessage({
      action: 'setTimeHideWidget',
      value: { type: selected.type, timestamp: time },
    });

    sendStatistics('hides');
  };

  return {
    setHide,
    setSelectedTime,
    selectedTime,
  };
};
